<template>
  <div>
    <v-app-bar color="primary" dense dark flat fixed app extension-height="25" class="tool-bar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="pl-0">
        <!-- <span class="ml-2">{{ $route.meta.title }}</span>
        <v-icon>{{ $route.meta.module_icon }}</v-icon>
        <v-icon class="pl-2">{{ $route.meta.action_icon }}</v-icon> -->
        <router-link to="/">
        <!-- <v-img src="images/logo.png" contain height="25" width="35" class="elevation-10 rounded white"></v-img> -->
        <v-img :src="company_details.logo_path" contain height="35" width="45" class="elevation-10 rounded white"></v-img>
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title class="pl-1">
        <!-- <span class="ml-2">{{ $route.meta.title }}</span>
        <v-icon>{{ $route.meta.module_icon }}</v-icon>
        <v-icon class="pl-2">{{ $route.meta.action_icon }}</v-icon> -->
        <!-- <v-btn icon dark @click="goBack()">
          <v-icon size="30"> mdi-arrow-left-bold-box-outline </v-icon>
        </v-btn> -->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="mr-0">
            <v-icon style="font-size: 30px;">mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/profile">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
      <template v-slot:extension>
        <div class="top-bar">
          <br>
        </div>
      </template>
    </v-app-bar>
    
    <v-navigation-drawer v-model="drawer" fixed temporary width="210px" :class="$route.meta.side_bar_class">
      <v-list-item>
        <v-list-item-avatar tile>
            <v-img height="25" width="35" :src="company_details.logo_path" contain></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{company_details.name}}</v-list-item-title>
          <small class="license-number">{{ company_details.license_number}}</small>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <template>
          <v-list-item @click="logout()" class="pa-0 pl-1 pr-1">
            <!-- <v-list-item-action>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action> -->
            <v-list-item-content>
              <v-list-item-title><v-icon class="error--text">mdi-logout</v-icon> <span style="font-size: 15px;" class="error--text">Logout</span> - <span class="caption">{{login_user_name}}</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider class="pb-2"></v-divider>
        <template v-for="item in items">
          <v-list-item
            v-if="item.child.length == 0"
            :key="item.text"
            link
            @click.prevent="(item.code == 'report')? resetReportFilter(item.to):redirectToWindow(item.to);"
          >
            <!-- <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action> -->
            <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
              <v-icon  dark right  class="sidebar_icon" @click.stop="redirectToNewWindow(item.to)">mdi-open-in-new </v-icon>
            </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :value="false"
            :key="item.text"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>  
            </template>
            <div v-for="childitem in item.child" :key="childitem.text">
              <v-list-group
                sub-group
                v-if="childitem.child && childitem.child.length > 0"
                class="set-left-padding"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ childitem.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="childitem2 in childitem.child"
                  :key="childitem2.text"
                  link
                  :to="childitem2.to"
                  @click.prevent="redirectToWindow(childitem2.to);"
                   class="pl-15"
                >
                  <v-list-item-title>{{ childitem2.text }}  <v-icon  dark right  class="sidebar_icon" @click="redirectToNewWindow(childitem2.to)">mdi-open-in-new </v-icon></v-list-item-title>
                </v-list-item>
              </v-list-group>
              <v-list-item
                v-else
                class="pl-10"
                link
                @click.prevent="redirectToWindow(childitem.to);"
              >
                <v-list-item-title>{{ childitem.text }}  <v-icon  dark right  class="sidebar_icon" @click="redirectToNewWindow(childitem.to)">mdi-open-in-new </v-icon></v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </template>
      </v-list>
      <v-list> </v-list>
    </v-navigation-drawer>
    <v-footer
      fixed 
      padless
      class="primary white--text custom-footer-width"
      height="30"
    >
      <v-col
        class="text-center pa-0"
        cols="12"
      >
        Copyright © {{ new Date().getFullYear() }} — <strong>{{company_details.name}}</strong>
      </v-col>
    </v-footer>
  </div>
</template>
<script>
import axios from "../plugins/axios";
import { getCompanyDetails, resetDateFilterValue } from "../plugins/helper";
export default {
  name: "Header",
  data() {
    return {
      drawer: false,
      company_details: getCompanyDetails(),
      items: [
        {
          icon: "mdi-monitor-dashboard",
          text: "Dashboard",
          to: "/dashboard",
          child: [],
        },
        {
          icon: "mdi-alpha-t-circle-outline",
          text: "Transaction",
          child: [
            {
              icon: "mdi-bank-transfer",
              text: "Bank Transactions",
              to: "/transaction",
            },
            {
              icon: "mdi-alpha-p-circle-outline",
              text: "Projects & Sales",
              to: "/projects",
              child: [],
            },
          ],
        },
        { icon: "mdi-bank-transfer", text: "Report", to: "/report/1", code: "report", child: [] },
        {
          icon: "mdi-alpha-t-circle-outline",
          text: "Account Master",
          child: [
            {
              icon: "mdi-account-cash",
              text: "Account",
              to: "/accounts",
            },
            { icon: "mdi-account-cog", text: "Vendor", to: "/vendors" },
            { icon: "mdi-account-cog", text: "Vendor Type", to: "/vendortype" },
            {
              icon: "mdi-account-circle-outline",
              text: "Customer",
              to: "/customers",
            },
          ],
        },

        {
          icon: "mdi-alpha-t-circle-outline",
          text: "Master Records",
          child: [
            // {
            //   icon: "mdi-account-cash",
            //   text: "Cabinet Master",
            //   child: [
            //     {
            //       icon: "mdi-account-cash",
            //       text: "Cabinet",
            //       to: "/cabinets",
            //     },
            //     { icon: "mdi-account-cog", text: "Color", to: "/cabinetcolor" },
            //     { icon: "mdi-account-cog", text: "Door Style", to: "/cabinetdoorstyle" },
            //     { icon: "mdi-account-cog", text: "Line", to: "/cabinetline" },
            //     { icon: "mdi-account-cog", text: "Type", to: "/cabinettype" },
            //     { icon: "mdi-account-cog", text: "Wood Type", to: "/cabinetwood" },
            //   ],
            // },
            { icon: "mdi-account-cog", text: "Item Master", to: "/items" },
            // {
            //   icon: "mdi-account-box-multiple-outline",
            //   text: "Job Master",
            //   to: "/jobs",
            // },
            {
              icon: "",
              text: "Job Type",
              to: "/jobtype",
            },
            {
              icon: "",
              text: "UOM",
              to: "/uom",
            },
            {
              icon: "",
              text: "Area",
              to: "/area",
            },
            {
              icon: "",
              text: "Item/Stone Group",
              to: "/group",
            },
            {
              text: "Color",
              to: "/color",
            },
            {
              icon: "",
              text: "Invoice Group",
              to: "/invoicegroup",
            },
            {
              icon: "",
              text: "Zip Code",
              to: "/zip",
            },
          ],
        },
        
        {
          icon: "mdi-alpha-t-circle-outline",
          text: "Company Setup",
          child: [
            {
              icon: "",
              text: "Company Info",
              to: "/company_info",
            },
            {
              icon: "mdi-account-box-multiple-outline",
              text: "User",
              to: "/users",
            },
            {
              icon: "",
              text: "Document Type",
              to: "/documenttype",
            },
            {
              icon: "",
              text: "Domain",
              to: "/domains",
            },
            { icon: "mdi-alpha-l-circle-outline", text: "Login Logs", to: "/loginlogs" },
            { icon: "mdi-alpha-l-circle-outline", text: "Role & Permission", to: "/role-permission" },
          ],
        },
        { icon: "mdi-account", text: "My Profile", to: "/profile", child: [] },
      ],
    };
  },
  computed: {
    login_user_name() {
      let user_name = localStorage.getItem('user_name')
      return user_name
    }
  },
  methods: {
    resetReportFilter(path) {
      resetDateFilterValue()
      this.$router.push({ path: path });
    },
    checkServerLogin() {
      axios.get('/user').then((data) => {
        console.log(data)
      })
    },
    redirectToWindow(route){
      localStorage.removeItem('is_from_project');
      localStorage.removeItem('is_from_dashboard');
      localStorage.removeItem('co_group_id');
      localStorage.removeItem('co_item_id');
      localStorage.removeItem('co_project_id');
      localStorage.removeItem('redirect_to');
      localStorage.removeItem('co_co_id');
      this.$router.push(route).catch(()=>{});
    },
    redirectToNewWindow(route){
      let routeData = this.$router.resolve({
        path: route,
      });
    //  window.open(routeData.href, '_blank');
    window.open(routeData.href,'_blank', 'newwindow','width=1200, height=700');
    },  
    redirectToRoute(route){
    localStorage.removeItem('is_from_project');
    localStorage.removeItem('is_from_dashboard');
    localStorage.removeItem('co_group_id');
    localStorage.removeItem('co_item_id');
    localStorage.removeItem('co_project_id');
    localStorage.removeItem('redirect_to');
    localStorage.removeItem('co_co_id');
    // this.$router.push(route)/
      let routeData = this.$router.resolve({
        path: route,
      });
    //  window.open(routeData.href, '_blank');
     window.open(routeData.href,'_blank', 'newwindow','width=1200, height=700');
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_id');
      localStorage.removeItem('company_data');
      localStorage.removeItem('is_from_project');
      localStorage.removeItem('is_from_dashboard');
      localStorage.removeItem('co_group_id');
      localStorage.removeItem('co_item_id');
      localStorage.removeItem('co_project_id');
      localStorage.removeItem('co_co_id');
      localStorage.removeItem('redirect_to');
      this.$router.push("/login");
    },
    goBack() {
      window.history.back()
    },
  },
  mounted : function(){
    this.checkServerLogin()
  }
};
</script>

<style>
.set-left-padding .v-list-group__header {
  padding-left: 0px !important;
}
.set-left-padding .v-list-item__icon {
  margin-left: 8px !important;
  margin-right: 8px !important; 
  margin-top: 5px !important;
}
</style>